import { render } from "./layoutMain.html?vue&type=template&id=6ee72cab&scoped=true&external"
import script from "./layoutMain.ts?vue&type=script&lang=js&external"
export * from "./layoutMain.ts?vue&type=script&lang=js&external"

import "./layoutMain.scss?vue&type=style&index=0&id=6ee72cab&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ee72cab"],['__file',"src/components/layout/layoutMain/index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "6ee72cab"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('6ee72cab', __exports__)) {
    api.reload('6ee72cab', __exports__)
  }
  
  module.hot.accept("./layoutMain.html?vue&type=template&id=6ee72cab&scoped=true&external", () => {
    api.rerender('6ee72cab', render)
  })

}


export default __exports__